import { RenderContentDaftarPenjualan } from "App/Component/layout/Penjualan/DaftarPenjualan/DaftarPenjualan";
import { Modal } from "App/Component/ui";
import { instance3, STYLE_DEFAULT_MASTER } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState, useContext } from "react";
import { FormContext } from "../../context/FormContext";

const urlDelete = "/poolKunjungan/delete";

export const deleteKunjunganById = async (id) => {
  try {
    const res = await instance3.post(urlDelete, { id });
    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "tagihan_id",
    disablePadding: true,
    label: "ID TAGIHAN",
    sort: false,
    align: "left",
  },
  {
    id: "tanggal",
    disablePadding: true,
    label: "TANGGAL",
    sort: false,
    align: "left",
  },
  {
    id: "nama_rm",
    disablePadding: true,
    label: "NAMA RM",
    sort: false,
    align: "left",
  },
  {
    id: "id_rm",
    disablePadding: true,
    label: "ID RM",
    sort: false,
    align: "left",
  },
  {
    id: "no_sep",
    disablePadding: true,
    label: "NO SEP",
    sort: false,
    align: "left",
  },
];

export const ModalListPenjualan = ({ setShowModal, setNewData }) => {
  const classes = STYLE_DEFAULT_MASTER();
  const [loading, setLoading] = useState(false);
  const { formData } = useContext(FormContext);

  const handleClickUpdate = async (row) => {
    if (isNull(formData.tagihan_id)) {
      defaultToastError("Buka tagihan terlebih dahulu");
    } else {
      const api = await instance3.post("/poolExternal/register", {
        tagihan_id: formData.tagihan_id,
        penjualan_id: row.id,
      });

      if (api.data.status === 200) {
        defaultToastSuccess("Berhasil menambah penjualan");
        await setNewData();
      } else {
        defaultToastError(api.data.message);
      }
      setShowModal(false);
    }
  };

  return (
    <Modal
      title={"Pencarian Penjualan Extenal"}
      width={"70%"}
      show={() => setShowModal(false)}>
      <RenderContentDaftarPenjualan
        handleClickUpdate={handleClickUpdate}
        onlyExternal={true}
        classes={classes}
        loading={loading}
        setLoading={setLoading}
      />
    </Modal>
  );
};
